import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta : {
      title: 'ＵＡゼンセン千葉県支部イベント管理システム'
    }
  },
  {
    path: '/edit',
    name: 'Edit',
    component: () => import('../views/Edit.vue'),
    meta : {
      title: 'ＵＡゼンセン千葉県支部イベント管理システム'
    }
  },
  {
    path: '/save',
    name: 'Save',
    component: () => import('../views/Save.vue'),
    meta : {
      title: 'ＵＡゼンセン千葉県支部イベント管理システム'
    }
  },
  {
    path: '/manage',
    name: 'Manage',
    component: () => import(/* webpackChunkName: "manage" */ '../views/Manage.vue'),
    meta : {
      title: 'ＵＡゼンセン千葉県支部イベント管理システム'
    }
  },
];

const router = new VueRouter({
  routes,
});

export default router;
